import { SET_CURRENT_USER } from './index'

export const setCurrentUser = user => ({
  type: SET_CURRENT_USER,
  user,
})
